// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__2uIek","main-section":"Home_main-section__fjWC_","container":"Home_container__9OuOz"};